<template>
  <div>
      <b-container fluid style="padding-top: 100px;">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
      <b-row>
          <b-col cols="12">
            <b-breadcrumb style="background-color: #e9ecef78;">

                <b-breadcrumb-item href="#home">
                  <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                    Home
                    </router-link>
                </b-breadcrumb-item>
                <b-breadcrumb-item href="#home">
                  <router-link to="/Gallery">
                    Gallery
                    </router-link>
                </b-breadcrumb-item>

               <b-breadcrumb-item href="#" active>APDCL Guest House, ASEB Colony, Narengi, Guwahati - 26</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
          <b-col cols="12">
            <span class="title">Gallery</span>
          </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div id="gal">
            <Tinybox v-model="index" :images="images"></Tinybox>
              <b-row >
                <b-col col cols="6" sm="3" md="3" ld="2" v-for="(img, idx) in images">
                  <img
                   :src="img.thumbnail"
                   :alt="img.alt"
                   class="open-tinybox thumb"
                   @click="index = idx"
                  >
                  <br>
                  <span align="center">{{ img.caption }}</span>
                </b-col>
            </b-row>
          </div>
      </b-col>
    </b-row>
    <br>
    </b-container>
  </div>
</template>

<style>
.thumb{
  height:120px;
  width:90%;
  margin-top:40px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.5s ease;
}
.thumb:hover
{
  /* transform: rotate(20deg); */
  transform: scale(1.12) rotate(-8deg);
}
.tinybox
{
  top:100px !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
</style>
<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
export default({
  components: {
    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    },

  data() {
    return {
      images: [
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_01.jpeg"),
          alt: "Alt 1",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_01.jpeg"),
          // caption: "Sunset-1"

        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_02.jpeg"),
          alt: "Alt 2",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_02.jpeg"),
          // caption: "Sunset-2"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_03.jpeg"),
          alt: "Alt 3",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_03.jpeg"),
          // caption: "Sunset-3"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_04.jpeg"),
          alt: "Alt 1",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_04.jpeg"),
          // caption: "Sunset-1"

        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_05.jpeg"),
          alt: "Alt 2",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_05.jpeg"),
          // caption: "Sunset-2"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_06.jpeg"),
          alt: "Alt 3",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_06.jpeg"),
          // caption: "Sunset-3"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_07.jpeg"),
          alt: "Alt 1",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_07.jpeg"),
          // caption: "Sunset-1"

        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_08.jpeg"),
          alt: "Alt 2",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_08.jpeg"),
          // caption: "Sunset-2"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_09.jpeg"),
          alt: "Alt 3",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_09.jpeg"),
          // caption: "Sunset-3"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_10.jpeg"),
          alt: "Alt 1",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_10.jpeg"),
          // caption: "Sunset-1"

        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_11.jpeg"),
          alt: "Alt 2",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_11.jpeg"),
          // caption: "Sunset-2"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_12.jpeg"),
          alt: "Alt 3",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_12.jpeg"),
          // caption: "Sunset-3"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_13.jpeg"),
          alt: "Alt 1",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_13.jpeg"),
          // caption: "Sunset-1"

        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_14.jpeg"),
          alt: "Alt 2",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_14.jpeg"),
          // caption: "Sunset-2"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_15.jpeg"),
          alt: "Alt 3",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_15.jpeg"),
          // caption: "Sunset-3"
        }
        ,
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_16.jpeg"),
          alt: "Alt 3",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_16.jpeg"),
          // caption: "Sunset-3"
        },
        {
          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_17.jpeg"),
          alt: "Alt 3",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_17.jpeg"),
          // caption: "Sunset-3"
        }
      ],
      index: null
    }
  }
});
</script>
